import React, { useState } from 'react';
import { Button, Group, Stack, Text, Badge, Box } from '@mantine/core';
import { ParkingBilling } from '../../models/parkingBilling.ts';
import useBatchConfirmParkingBillingBillings from '../../hooks/useBatchConfirmParkingBillingBillings.ts';

export default function BatchConfirmBillingModal({
  billings = [],
  onClose,
}: {
  billings: ParkingBilling[];
  onClose: () => void;
}) {
  const { mutate, isPending } = useBatchConfirmParkingBillingBillings();
  const [result, setResult] = useState<{
    success: number;
    failure: number;
    failureBillings: ParkingBilling[];
  } | null>(null);

  const handleConfirm = () => {
    const ids = billings.map((b) => b.id);
    mutate(ids, {
      onSuccess: (items) => {
        const failure = items.filter((x) => x.error).map((x) => x.id);
        const failureBillings = billings.filter((b) => failure.includes(b.id));
        const success = items.length - failure.length;
        setResult({ success, failure: failure.length, failureBillings });
      },
    });
  };
  return (
    <Stack>
      {result ? (
        <Box>
          <Text>
            本批次 {billings.length} 筆，成功 {result.success} 筆，失敗{' '}
            {result.failure} 筆
          </Text>
          {result.failureBillings.length > 0 && (
            <Box>
              <Text>確認失敗的對帳單</Text>
              {result.failureBillings.map((failureBilling) => (
                <Text>{failureBilling.name}</Text>
              ))}
            </Box>
          )}
          <Group mt="sm">
            <Button variant="outline" onClick={onClose} disabled={isPending}>
              關閉
            </Button>
          </Group>
        </Box>
      ) : (
        <>
          <Text size="sm">以下對帳單將被確認，共 {billings.length} 筆：</Text>
          <Box>
            {billings.map((b) => (
              <Badge variant="outline" size="sm" mx="xs">
                {b.name}
              </Badge>
            ))}
          </Box>
          <Group mt="md">
            <Button variant="outline" onClick={onClose} disabled={isPending}>
              取消
            </Button>
            <Button onClick={handleConfirm} loading={isPending}>
              確認
            </Button>
          </Group>
        </>
      )}
    </Stack>
  );
}
